import { Injectable } from '@angular/core';

import { Observable, of, Subject } from 'rxjs';
import { environment } from '../../environments/environment';
import { AccountService } from '../modules/aaacommon/api/account.service';
import { Account } from '../modules/aaacommon/interface/account';
import { User } from '../modules/aaacommon/interface/user';

@Injectable({
  providedIn: 'root',
})
export class CurrentUserService {
  currentUser: User = <User>{ id: 'superuser' };
  isSuperAdmin = false;
  isSuperRead = false;
  isAdmin = false;
  isUser = false;
  isNoAccess = false;
  isReseller = false;

  private _isAdminReseller = false;
  private isAdminResellerSubject = new Subject<boolean>();

  /**
   * An asynchronous way of checking whether the current user
   * is either a Super Admin or an Admin under a Reseller-type account.
   */
  get isAdminReseller(): Observable<boolean> {
    return this.isAdminResellerSubject.closed
      ? of(this._isAdminReseller)
      : this.isAdminResellerSubject.asObservable();
  }

  constructor(private accountService: AccountService) {
    if (environment.userInfo) {
      this.setCurrentUser(environment.userInfo as any);
    }
  }

  setCurrentUser(user: User) {
    console.log('USER LOGIN:', user);
    if (!user) {
      return;
    }
    this.currentUser = user;
    this.accountService
      .getAccount(user.accountId)
      .subscribe((account: Account) => {
        this.isReseller = account.type === 'Reseller';
        this.emitIsAdminReseller(this.isAdmin && this.isReseller);
      });
    const application = user.applicationRoles.find(
      (app) => app.application === 'RiverheadClient',
    );
    if (application) {
      if (application.userRole === 'riverhead_super_admin') {
        this.isSuperAdmin = true;
        this.emitIsAdminReseller(true);
      } else if (application.userRole === 'riverhead_read_super_admin') {
        this.isSuperRead = true;
      } else if (application.userRole === 'riverhead_admin') {
        this.isAdmin = true;
      } else if (application.userRole === 'riverhead_user') {
        this.isUser = true;
      } else if (application.userRole === 'riverhead_no_access') {
        this.isNoAccess = true;
      }
    } else {
      this.isNoAccess = true;
    }
  }

  private emitIsAdminReseller(value: boolean) {
    if (!this.isAdminResellerSubject.closed) {
      this._isAdminReseller = value;
      this.isAdminResellerSubject.next(value);
      this.isAdminResellerSubject.unsubscribe();
    }
  }

  canEditThisUser(user: User) {
    if (this.isSuperAdmin) {
      return true;
    }
    const hasInternalRole = user.applicationRoles
      .map((roleObj) => roleObj.userRole)
      .find((role) => this.isSuperAdminRole(role));
    const hasInternalUserGroup =
      user.userGroups &&
      user.userGroups
        .map((userGroup) => userGroup.name)
        .find((role) => this.isSuperAdminRole(role));
    return !(hasInternalRole || hasInternalUserGroup);
  }

  isSuperAdminRole(role: string) {
    return role && (role.includes('_super') || role.includes('_internal'));
  }
}
